/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ResponseReasoningTextDeltaEvent = {
  type: "response.reasoning_text.delta";
  sequenceNumber: number;
  itemId: string;
  outputIndex: number;
  contentIndex: number;
  delta: string;
};

/** @internal */
export const ResponseReasoningTextDeltaEvent$inboundSchema: z.ZodType<
  ResponseReasoningTextDeltaEvent,
  z.ZodTypeDef,
  unknown
> = z.object({
  type: z.literal("response.reasoning_text.delta"),
  sequence_number: z.number().int(),
  item_id: z.string(),
  output_index: z.number().int(),
  content_index: z.number().int(),
  delta: z.string(),
}).transform((v) => {
  return remap$(v, {
    "sequence_number": "sequenceNumber",
    "item_id": "itemId",
    "output_index": "outputIndex",
    "content_index": "contentIndex",
  });
});
/** @internal */
export type ResponseReasoningTextDeltaEvent$Outbound = {
  type: "response.reasoning_text.delta";
  sequence_number: number;
  item_id: string;
  output_index: number;
  content_index: number;
  delta: string;
};

/** @internal */
export const ResponseReasoningTextDeltaEvent$outboundSchema: z.ZodType<
  ResponseReasoningTextDeltaEvent$Outbound,
  z.ZodTypeDef,
  ResponseReasoningTextDeltaEvent
> = z.object({
  type: z.literal("response.reasoning_text.delta"),
  sequenceNumber: z.number().int(),
  itemId: z.string(),
  outputIndex: z.number().int(),
  contentIndex: z.number().int(),
  delta: z.string(),
}).transform((v) => {
  return remap$(v, {
    sequenceNumber: "sequence_number",
    itemId: "item_id",
    outputIndex: "output_index",
    contentIndex: "content_index",
  });
});

export function responseReasoningTextDeltaEventToJSON(
  responseReasoningTextDeltaEvent: ResponseReasoningTextDeltaEvent,
): string {
  return JSON.stringify(
    ResponseReasoningTextDeltaEvent$outboundSchema.parse(
      responseReasoningTextDeltaEvent,
    ),
  );
}
export function responseReasoningTextDeltaEventFromJSON(
  jsonString: string,
): SafeParseResult<ResponseReasoningTextDeltaEvent, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ResponseReasoningTextDeltaEvent$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ResponseReasoningTextDeltaEvent' from JSON`,
  );
}
